import axios from 'axios'
import { genURL } from "../../_getjson";
import { checkData } from '../../_source/checkDatainput'
export default async function Checkmaingroup(code) {
    let rs = ""
    // console.log("chks", code, QUANTITY, arcode, UNITCODE, TAXTYPE, OrderDate);
    let url = "CSPRODUCT/Code?code=" + code;
    if (typeof (code) !== "undefined") {
        await axios.get(genURL(url), { timeout: 4800 }).then((res) => {
            if (res.data.length > 0) {
                console.log("res MAINGROUP", code, ":::::", res.data[0].MAINGROUP);
                rs = checkData("text", res.data[0].MAINGROUP)
            }
            // this.ReLoadData()
        })
    } else {
        rs = ""
    }
    return rs
};